/*eslint-disable*/

import { SaleDTO } from 'src/dto/sale'
import { v4 as uuidv4 } from 'uuid'

export interface SaleParams {
  idFazenda: string
  idVenda?: string
  animais?: string[]
  sync?: boolean
  delete?: boolean
  acao?: 'Atualizacao' | 'Removido'
  idLote?: string | null
  valorArroba?: string
  valorTotal?: string
  comprador?: string | null
  data?: string | null
  descricaoLote?: string | null
  animalList?: any[]
  tipoVenda?: 'animal' | 'lote' | null
  key?: string
  id?: string
}

export class Sale implements SaleDTO {
  idVenda: string
  idFazenda: string
  animais: string[]
  sync = false
  delete?: boolean
  acao = 'Atualizacao' as 'Atualizacao' | 'Removido'

  idLote: string | null
  valorArroba: string
  valorTotal: string
  comprador: string | null
  data: string | null
  descricaoLote: string | null
  animalList: any[]

  tipoVenda: 'animal' | 'lote' | null
  key: string
  id: string

  constructor({
    idFazenda,
    idVenda = uuidv4(),
    animais = [],
    sync = false,
    delete: deleteFlag,
    acao = 'Atualizacao',
    idLote = null,
    valorArroba = '',
    valorTotal = '',
    comprador = null,
    data = null,
    descricaoLote = null,
    animalList = [],
    tipoVenda = null,
    key = 'idVenda',
    id
  }: SaleParams) {
    this.idFazenda = idFazenda
    this.idVenda = idVenda
    this.animais = animais
    this.sync = sync
    this['delete'] = deleteFlag
    this.acao = acao
    this.idLote = idLote
    this.valorArroba = this.normalizeToFloatString(valorArroba)
    this.valorTotal = this.normalizeToFloatString(valorTotal)
    this.comprador = comprador
    this.data = data
    this.descricaoLote = descricaoLote
    this.animalList = animalList
    // Garantir que tipoVenda sempre tenha um valor válido
    this.tipoVenda = tipoVenda || (idLote ? 'lote' : 'animal')
    this.key = key
    this.id = id ?? idVenda
  }

  private normalizeToFloatString(value: any): string {
    if (value == null || value === '') return '0.0'

    if (typeof value === 'string') {
      // Remove formatação de moeda (R$, pontos de milhar) e converte vírgula para ponto
      const cleaned = value.replace(/[^0-9,-]+/g, '').replace(',', '.')
      const numericValue = parseFloat(cleaned) || 0
      return numericValue.toString()
    }

    if (typeof value === 'number') {
      return value.toString()
    }

    return '0.0'
  }
}
